import { createSelector } from 'reselect'

export const getServiceTypes = createSelector(
  state => state && state.ads && state.ads.serviceTypes && Array.isArray(state.ads.serviceTypes.elements)
    ? state.ads.serviceTypes.elements : [],
  serviceTypes => serviceTypes
)
